import { SET_HOME, SET_SUBSCRIPTION, SET_PROFILE, SET_DIETITIAN, SET_REFERAL, SET_HISTORY, SET_SETTINGS, } from "../actions/types";
const initState = {
    home: true,
    subscription: true,
    profile: true,
    dietitian: true,
    referal: true,
    history: true,
    settings: true,
};
export default function checkStoreReducer(state = initState, action) {
    switch (action.type) {
        case SET_HOME: {
            return {
                ...state,
                home: action.payload,
            };
        }
        case SET_SUBSCRIPTION: {
            return {
                ...state,
                subscription: action.payload,
            };
        }
        case SET_PROFILE: {
            return {
                ...state,
                profile: action.payload,
            };
        }
        case SET_DIETITIAN: {
            return {
                ...state,
                dietitian: action.payload,
            };
        }
        case SET_REFERAL: {
            return {
                ...state,
                referal: action.payload,
            };
        }
        case SET_HISTORY: {
            return {
                ...state,
                history: action.payload,
            };
        }
        case SET_SETTINGS: {
            return {
                ...state,
                settings: action.payload,
            };
        }
        default:
            return state;
    }
}
